import React from 'react'

const IconHeading = ({ color = 'currentColor', ...rest }) => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none' {...rest}>
            <path
                d='M4 7.99999H12M4 13.3333V2.66666M12 13.3333V2.66666'
                stroke={color}
                stroke-width='1.25'
                stroke-linecap='round'
                stroke-linejoin='round'
            />
        </svg>
    )
}

export default IconHeading
